import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setMode } from "@/lib/api";
import { trackDemo } from "@/lib/demoTrack";
import { AlertTriangle, Siren } from "lucide-react";

// Persistent Demo Mode banner — shown at the top of every Demo screen.
export default function DemoBanner() {
  const [confirming, setConfirming] = useState(false);
  const navigate = useNavigate();

  const startLive = () => {
    trackDemo("exit_to_live");
    setMode("LIVE");
    navigate("/dashboard?live=1");
  };

  const openConfirm = () => {
    trackDemo("exit_confirm_shown");
    setConfirming(true);
  };

  return (
    <>
      <div className="sticky top-0 z-[90] bg-amber-400 text-navy shadow-md" data-testid="demo-banner">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 font-heading font-extrabold text-sm tracking-wide">
              <AlertTriangle className="w-4 h-4 shrink-0" /> DEMO MODE — No professionals are being contacted and no information is being saved.
            </div>
            <div className="text-xs text-navy/80 mt-0.5">If you are currently involved in an accident, exit Demo Mode and select the red LIVE ACCIDENT button.</div>
          </div>
          <button onClick={openConfirm} data-testid="demo-exit-btn"
            className="shrink-0 flex items-center gap-1.5 bg-red-600 hover:bg-red-700 text-white text-xs font-bold px-4 py-2.5 rounded-full transition-all active:scale-95">
            <Siren className="w-4 h-4" /> EXIT DEMO AND START LIVE ACCIDENT
          </button>
        </div>
      </div>

      {confirming && (
        <div className="fixed inset-0 z-[110] bg-navy/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="demo-exit-confirm">
          <div className="bg-white rounded-3xl p-7 w-full max-w-md text-center shadow-2xl">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-red-50 flex items-center justify-center"><Siren className="w-7 h-7 text-red-600" /></div>
            <h2 className="mt-4 font-heading text-xl font-extrabold text-navy">Are you currently involved in an actual accident?</h2>
            <p className="mt-2 text-sm text-slate-500">Live Mode creates a real accident report and may notify verified professionals later in the workflow.</p>
            <div className="mt-6 space-y-2.5">
              <button onClick={startLive} data-testid="demo-exit-yes"
                className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3.5 rounded-full transition-all active:scale-[0.99]">
                YES — START LIVE ACCIDENT
              </button>
              <button onClick={() => setConfirming(false)} data-testid="demo-exit-no"
                className="w-full bg-white border border-slate-200 text-slate-600 font-semibold py-3.5 rounded-full hover:bg-slate-50 transition-all">
                NO — RETURN TO DEMO
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
